import React, { FC, useState } from 'react';
import { TurbineInfo } from './Landing.slice';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import amlogo from '../../../assets/images/Annotation_manager.png';
import stlogo from '../../../assets/images/Stitching_tool.png';
import { Button } from 'antd';
import { whereToNavigate } from './Helpers';
import { RestoreModal, RestoreSuccessModal } from '../../Shared/RestoreModal';
import axios from '../../../axios';
import { ToastAnt } from '../../Shared/Toast/ToastAnt';
import { describeRestoreNoOp, isRestoreQueued } from '../restoreOutcome';

type Props = {
  record: TurbineInfo;
};

const TurbineTableAction: FC<Props & RouteComponentProps> = ({ record, history, location }) => {
  const { annotationManagerMode } = whereToNavigate(location);
  const [restoreVisible, setRestoreVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  const turbinePath = `${record.site}/${record.inspection}/${record.turbine}`;
  const turbineDisplayPath = turbinePath.replace(/\//g, ' / ');

  const onOpenStitchingTool = () => {
    history.push({
      pathname: `/stitching-tool/${turbinePath}`
    });
  };

  const onOpenAnnotationManager = () => {
    history.push({
      pathname: `/annotation-manager/windturbine/${turbinePath}`
    });
  };

  const onRestoreRequest = async (restoreDays: number) => {
    try {
      const { data } = await axios.post('turbine/restore', {
        turbineId: record.turbineId,
        restoreDays
      });
      setRestoreVisible(false);

      // Only claim a restore was submitted when one actually was.
      if (isRestoreQueued(data)) {
        setSuccessVisible(true);
      } else {
        ToastAnt(describeRestoreNoOp(data));
      }
    } catch {
      ToastAnt('Failed to submit restore request. Please try again.');
      throw new Error('Restore request failed');
    }
  };

  if (record.isArchived) {
    return (
      <div>
        <Button size='large' onClick={() => setRestoreVisible(true)}>
          Restore from Archive
        </Button>
        <RestoreModal
          visible={restoreVisible}
          turbinePath={turbineDisplayPath}
          onRequest={onRestoreRequest}
          onCancel={() => setRestoreVisible(false)}
        />
        <RestoreSuccessModal
          visible={successVisible}
          turbinePath={turbineDisplayPath}
          onClose={() => setSuccessVisible(false)}
        />
      </div>
    );
  }

  return (
    <div>
      <Button
        size='large'
        onClick={onOpenStitchingTool}
        title='Stitching Tool'
        disabled={!record.canOpenStitchingTool}
        style={{ marginRight: '20px' }}
      >
        <div style={{ height: '100%' }}>
          <img style={{ height: '100%' }} src={stlogo} alt='st' />
        </div>
      </Button>
      {annotationManagerMode && (
        <Button size='large' onClick={onOpenAnnotationManager} title='Annotation Module' disabled={!record.canOpenAnnotationManager}>
          <div style={{ height: '100%' }}>
            <img style={{ height: '100%' }} src={amlogo} alt='am' />
          </div>
        </Button>
      )}
    </div>
  );
};

export default withRouter(TurbineTableAction);
